module.exports = isPromise;

function isPromise(obj) {
  return obj && typeof obj.then === 'function';
}


//////////////////
// WEBPACK FOOTER
// ./~/is-promise/index.js
// module id = 116
// module chunks = 0